<template>
  <div :style="{ 'min-height': `${winHeight - boxHeight - 100}px` }">
    <div style="text-align: center" class="my-n5">
      <h6 class="my-8 blue--text">
        گفتگو
        {{
          $store.getters.fullName && $route.path == '/merchant-messages'
            ? ' با ' + $store.getters.fullName
            : ''
        }}
        درباره {{ topicDisplayName(topic) }}
      </h6>
    </div>
    <v-row
      v-if="
        $route.path == '/merchant-messages' && $vuetify.breakpoint.smAndDown
      "
    >
      <v-col cols="12">
        <v-btn
          icon
          class="float-left ml-3"
          color="error"
          small
          @click="
            $store.commit('setShowThread', false);
            $store.commit('setShowConv', true);
          "
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <div
      id="scroll"
      class="mt-3"
      :style="{
        'overflow-x': 'hidden',
        'overflow-y': 'auto',
        height: `${divHeight - boxHeight - 135}px`,
      }"
    >
      <v-row v-for="(chat, index) in isReads" :key="index">
        <v-col cols="12">
          <v-card
            :id="chat.id"
            outlined
            :color="
              parentToBeReplied != chat.id && chat.isMine
                ? 'grey lighten-5'
                : parentToBeReplied != chat.id && !chat.isMine
                ? 'light-blue lighten-5'
                : parentToBeReplied == chat.id
                ? 'grey lighten-2'
                : ''
            "
            :max-width="$vuetify.breakpoint.mdAndUp ? '60%' : '90%'"
            min-width="35%"
            :class="{
              'mx-16': $vuetify.breakpoint.mdAndUp,
              '': $vuetify.breakpoint.smAndDown,
              'float-right': chat.isMine,
              'float-left': !chat.isMine,
            }"
          >
            <v-card-text>
              <a
                :href="`#${chat.parentId}`"
                @click="parentToBeReplied = chat.parentId"
              >
                <v-alert
                  class="attachment"
                  v-if="chat.parentBody"
                  border="right"
                  :color="
                    chat.isMine ? 'grey lighten-3' : 'light-blue lighten-4'
                  "
                >
                  {{
                    chat.parentBody &&
                    chat.parentBody.length > 30 &&
                    $vuetify.breakpoint.mdAndUp
                      ? chat.parentBody.slice(0, 30)
                      : chat.parentBody &&
                        chat.parentBody.length > 15 &&
                        $vuetify.breakpoint.smAndDown
                      ? chat.parentBody.slice(0, 15)
                      : chat.parentBody
                  }}
                </v-alert>
              </a>

              <div class="d-flex flex-row justify-content-between">
                <small class="mr-2"> {{ chat.relativeTime }} </small>
                <div>
                  <v-btn
                    icon
                    color="primary"
                    x-small
                    @click="editChat(chat)"
                    v-if="chat.status != 'IsRead' && chat.isMine"
                  >
                    <v-icon> mdi mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon color="grey" x-small @click="replyChat(chat)">
                    <v-icon> mdi mdi-reply</v-icon>
                  </v-btn>
                </div>
              </div>
              <div class="my-2">
                <strong>{{ chat.body }}</strong>
              </div>
              <div v-if="chat.attachments && chat.attachments.length > 0">
                <div class="d-flex flex-row flex-wrap">
                  <div
                    class="m-3"
                    v-for="(attachment, index) in chat.attachments"
                    :key="index"
                  >
                    <v-img
                      :src="attachment.thumbnailFileUrl"
                      width="100"
                      height="100"
                      class="attachment"
                      @click="openImage(attachment.fileUrl)"
                    ></v-img>
                  </div>
                </div>
              </div>
              <div v-if="chat.status == 'IsRead'">
                <span>خوانده شده</span>
              </div>
              <div v-if="chat.status == 'Sent'">
                <span>ارسال شده</span>
              </div>
              <div v-if="chat.status == 'IsModified'">
                <span>ویرایش شده</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <div
        id="unRead"
        v-if="isntRead && isntRead.length"
        style="{
          width: 100%,
          height: 10px,
          border-bottom: 1px solid black,
          text-align: center,}
        "
        class="my-4"
      >
        <span
          style="font-size: 11px; background-color: #ffffff"
          class="mb-n2 pa-3"
        >
          خوانده نشده
          <!--Padding is optional-->
        </span>
      </div>
      <v-row v-for="(chat, index) in isntRead" :key="index">
        <v-col cols="12">
          <v-card
            :id="chat.id"
            outlined
            :color="
              parentToBeReplied != chat.id && chat.isMine
                ? 'grey lighten-5'
                : parentToBeReplied != chat.id && !chat.isMine
                ? 'light-blue lighten-5'
                : parentToBeReplied == chat.id
                ? 'grey lighten-2'
                : ''
            "
            :max-width="$vuetify.breakpoint.mdAndUp ? '60%' : '90%'"
            min-width="35%"
            :class="{
              'mx-16': $vuetify.breakpoint.mdAndUp,
              '': $vuetify.breakpoint.smAndDown,
              'float-right': chat.isMine,
              'float-left': !chat.isMine,
            }"
          >
            <v-card-text>
              <a
                :href="`#${chat.parentId}`"
                @click="parentToBeReplied = chat.parentId"
              >
                <v-alert
                  class="attachment"
                  v-if="chat.parentBody"
                  border="right"
                  color="grey lighten-3"
                >
                  {{
                    chat.parentBody &&
                    chat.parentBody.length > 30 &&
                    $vuetify.breakpoint.mdAndUp
                      ? chat.parentBody.slice(0, 30)
                      : chat.parentBody &&
                        chat.parentBody.length > 15 &&
                        $vuetify.breakpoint.smAndDown
                      ? chat.parentBody.slice(0, 15)
                      : chat.parentBody
                  }}
                </v-alert>
              </a>
              <div class="d-flex flex-row justify-content-between">
                <div>
                  <small class="mr-2"> {{ chat.relativeTime }} </small>

                  <v-btn
                    icon
                    color="primary"
                    x-small
                    @click="editChat(chat)"
                    v-if="chat.status != 'IsRead' && chat.isMine"
                  >
                    <v-icon> mdi mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon color="grey" x-small @click="replyChat(chat)">
                    <v-icon> mdi mdi-reply</v-icon>
                  </v-btn>
                </div>
              </div>
              <div class="my-2">
                <strong>{{ chat.body }}</strong>
              </div>
              <div v-if="chat.attachments && chat.attachments.length > 0">
                <div class="d-flex flex-row flex-wrap">
                  <div
                    class="m-3"
                    v-for="(attachment, index) in chat.attachments"
                    :key="index"
                  >
                    <v-img
                      :src="attachment.thumbnailFileUrl"
                      width="100"
                      height="100"
                      class="attachment"
                      @click="openImage(attachment.fileUrl)"
                    ></v-img>
                  </div>
                </div>
              </div>
              <div v-if="chat.status == 'IsRead'">
                <span>خوانده شده</span>
              </div>
              <div v-if="chat.status == 'Sent'">
                <span>ارسال شده</span>
              </div>
              <div v-if="chat.status == 'IsModified'">
                <span>ویرایش شده</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-for="(chat, index) in newThreads" :key="index">
        <v-col cols="12">
          <v-card
            :id="chat.id"
            outlined
            :color="
              parentToBeReplied != chat.id && chat.isMine
                ? 'grey lighten-5'
                : parentToBeReplied != chat.id && !chat.isMine
                ? 'light-blue lighten-5'
                : parentToBeReplied == chat.id
                ? 'grey lighten-2'
                : ''
            "
            :max-width="$vuetify.breakpoint.mdAndUp ? '60%' : '90%'"
            min-width="35%"
            :class="{
              'mx-16': $vuetify.breakpoint.mdAndUp,
              '': $vuetify.breakpoint.smAndDown,
              'float-right': chat.isMine,
              'float-left': !chat.isMine,
            }"
          >
            <v-card-text>
              <a
                :href="`#${chat.parentId}`"
                @click="parentToBeReplied = chat.parentId"
              >
                <v-alert
                  class="attachment"
                  v-if="chat.parentBody"
                  border="right"
                  color="grey lighten-3"
                >
                  {{
                    chat.parentBody &&
                    chat.parentBody.length > 30 &&
                    $vuetify.breakpoint.mdAndUp
                      ? chat.parentBody.slice(0, 30)
                      : chat.parentBody &&
                        chat.parentBody.length > 15 &&
                        $vuetify.breakpoint.smAndDown
                      ? chat.parentBody.slice(0, 15)
                      : chat.parentBody
                  }}
                </v-alert>
              </a>
              <div class="d-flex flex-row justify-content-between">
                <div>
                  <small class="mr-2">{{ chat.relativeTime }} </small>
                  <!-- <small class="mr-2">({{ chat.relativeTime}})</small> -->

                  <v-btn
                    icon
                    color="primary"
                    x-small
                    @click="editChat(chat)"
                    v-if="chat.status != 'IsRead'"
                  >
                    <v-icon> mdi mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon color="grey" x-small @click="replyChat(chat)">
                    <v-icon> mdi mdi-reply</v-icon>
                  </v-btn>
                </div>
              </div>
              <div class="my-2">
                <strong>{{ chat.body }}</strong>
              </div>
              <div v-if="chat.attachments && chat.attachments.length > 0">
                <div class="d-flex flex-row flex-wrap">
                  <div
                    class="m-3"
                    v-for="(attachment, index) in chat.attachments"
                    :key="index"
                  >
                    <v-img
                      :src="attachment.thumbnailFileUrl"
                      width="100"
                      height="100"
                      class="attachment"
                      @click="openImage(attachment.fileUrl)"
                    ></v-img>
                  </div>
                </div>
              </div>
              <div v-if="chat.status == 'IsRead'">
                <span>خوانده شده</span>
              </div>
              <div v-if="chat.status == 'Sent'">
                <span>ارسال شده</span>
              </div>
              <div v-if="chat.status == 'IsModified'">
                <span>ویرایش شده</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div id="messsageBox" class="mt-3">
      <ConversationReply
        v-if="showReply"
        @addNewThread="addNewThread"
        @closeReplyForm="closeReplyForm"
        @getConversaion="getConversaion"
        @setSelectedToReply="setSelectedToReply"
        :showReply="showReply"
        :selectedToReply="selectedToReply"
        :conversationId="conversationId"
        :createdByMerchantId="createdByMerchantId"
        :topic="topic"
        :recipientMerchantId="recipientMerchantId"
        :recipientUserId="recipientUserId"
        :type="type"
        :objectId="objectId"
      >
      </ConversationReply>
      <ConversationForm
        v-if="
          !showReply &&
          openEditChat &&
          selectedChatForEdit &&
          selectedChatForEdit.id
        "
        @closeChatForm="closeChatForm"
        @getConversaion="getConversaion"
        :chatIsEdit="true"
        :selectedChatForEdit="selectedChatForEdit"
        :conversationId="conversationId"
        :topic="topic"
        :recipientMerchantId="recipientMerchantId"
        :recipientUserId="recipientUserId"
        :type="type"
        :objectId="objectId"
        :createdByMerchantId="createdByMerchantId"
        :isUserBase="isUserBase"
      >
      </ConversationForm>
      <ConversationForm
        v-if="!showReply && !openEditChat"
        :conversationId="conversationId"
        :topic="topic"
        :type="type"
        :objectId="objectId"
        :recipientMerchantId="recipientMerchantId"
        :recipientUserId="recipientUserId"
        :createdByMerchantId="createdByMerchantId"
        :isUserBase="isUserBase"
        @getConversationId="getConversationId"
        @addNewThread="addNewThread"
        @closeChatForm="closeChatForm"
        @getConversaion="getConversaion"
      >
      </ConversationForm>
    </div>
  </div>
</template>

<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import ConversationReply from './ConversationReply';
const enumsRepository = () => RepoFactory.get('enums');
import ConversationForm from './ConversationForm';
import { GET_ENUMS } from '@/modules/enums/store/types';
import Helper from '@/core/helpers';
import { RepoFactory } from '@/baseRepository/Factory';
const authRepository = () => RepoFactory.get('auth');
const conversationRepository = () => RepoFactory.get('conversation');
const notificationRepository = () => RepoFactory.get('notification');
export default {
  props: {
    conversationId: {
      type: String,
    },
    type: {
      type: String,
    },
    topic: {
      type: String,
    },
    objectId: {
      type: String,
    },
    recipientMerchantId: {
      type: String,
    },
    recipientUserId: {
      type: String,
    },
    createdByMerchantId: {
      type: String,
    },
    isUserBase: {
      type: Boolean,
      default:null,
    }
  },
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  components: {
    ConversationReply,
    ConversationForm,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    contentBaseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    notificationBaseUrl() {
      return this.$store.getters.notificationBaseUrl;
    },
    MerchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  watch: {
    pageNumber(after, before) {
      this.getConversaion();
    },
  },
  created() {
    // -------------------------------------------------------//
    this.connection = new this.$signalR.HubConnectionBuilder()
      .withUrl(`${this.$store.getters.notificationBaseUrl}/hub/notification`, {
        accessTokenFactory: () =>
          localStorage.getItem('taksan_supplier_access_token'),
      })
      // .withUrl(`${this.notificationBaseUrl}/hub/notification`)
      .withAutomaticReconnect()
      .configureLogging(this.$signalR.LogLevel.Information)
      .build();
    this.connection.onclose(async () => {
      await this.start();
    });
    this.start();
    // -------------------------------------------------------///
    this.getTopics();
  },
  mounted() {
    const loader = this.$loading.show();
    let param = {
      objectId: this.conversationId ? null : this.objectId,
      type: this.conversationId ? null : this.type,
      topic: this.conversationId ? null : this.topic,
      PageNumber: 1,
      ItemsPerPage: 10,
      conversationId: this.conversationId ? this.conversationId : null,
    };
    conversationRepository()
      .getConversation(this.$store.getters.contentBaseUrl, {}, param)
      .then((res) => {
        let pg;
        pg = Math.floor(res.data.totalCount / this.itemsPerPage);
        if (res.data.totalCount % this.itemsPerPage != 0) {
          pg += 1;
        }
        this.pageNumber = 1;
        this.pageCount = pg;
        loader.hide();
        document
          .getElementById('scroll')
          .addEventListener('scroll', this.onScroll);
      })
      .catch((err) => {
        loader.hide();
      });
    this.winHeight = window.innerHeight;
    let h1 = document.getElementById('scroll').offsetHeight;
    let h2 = document.getElementById('messsageBox').offsetHeight;
    this.boxHeight = document.getElementById('messsageBox').offsetHeight;
    this.divHeight = this.winHeight - h2;
    // window.addEventListener("scroll", this.onScroll);
  },
  data() {
    return {
      counter: 0,
      firstTime: true,
      windowTop: null,
      pageCount: 0,
      pageNumber: 0,
      itemsPerPage: 5,
      connection: '',
      winHeight: 0,
      scrollHeight: 0,
      divHeight: 0,
      boxHeight: 0,
      newThreads: [],
      conversaionList: null,
      user: null,
      isReads: [],
      isntRead: [],
      topicList: [],
      showReply: false,
      selectedToReply: null,
      parentToBeReplied: null,
      showReply: false,
      openNewChatForm: false,
      openEditChat: false,
      selectedChatForEdit: null,
    };
  },

  methods: {
    onScroll(e) {
      this.windowTop = e.target.scrollTop;
      if (this.windowTop == 0) {
        if (this.pageNumber < this.pageCount) {
          this.pageNumber++;
        }
      }
    },
    scrollTopList() {
      document.getElementById('homePage').scrollIntoView();
    },
    setSelectedToReply(val) {
      this.selectedToReply = val;
    },
    getTopics() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum(
          'ConversationCategoryTopic',
          this.$store.getters.contentBaseUrl
        )
        .then((res) => {
          this.topicList = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    topicDisplayName(title) {
      if (this.topicList.length) {
        let result = this.topicList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    async start() {
      try {
        await this.connection.start();
        console.log('SignalR Connected.');
        this.$store.dispatch(
          'getUnreadTreadeConversation',
          this.$store.getters.currentMerchant
        );
        this.getunseenUserNotificationRealTime();
      } catch (err) {}
    },
    getunseenUserNotificationRealTime() {
      this.connection.on('RecieveNotification', (message) => {
        console.log(message);
        conversationRepository()
          .getConversationById(
            message.conversationId,
            this.$store.getters.contentBaseUrl,
            {},
            { threadId: message.threadId }
          )
          .then((res) => {
            this.newThreads.push(res.data);
          })
          .catch((err) => {
            Helper.handleErrors(err, this);
          });
      });
    },
    getConversationId(val) {
      this.$emit('getConversationId', val);
    },
    addNewThread(thread) {
      this.newThreads.push(thread);
      this.closeReplyForm();
      this.closeChatForm();

      setTimeout(() => {
        let h = document.getElementById('scroll');
        h.scrollTop = h.scrollHeight;
      }),
        100;
    },
    getConversaion() {
      const loader = this.$loading.show();
      let param = {
        objectId: this.conversationId ? null : this.objectId,
        type: this.conversationId ? null : this.type,
        topic: this.conversationId ? null : this.topic,
        PageNumber: this.pageNumber,
        ItemsPerPage: this.itemsPerPage,
        conversationId: this.conversationId ? this.conversationId : null,
      };
      if (this.isUserBase) {
        param.isUserBased = true;
      }
      conversationRepository()
        .getConversation(
          this.$store.getters.contentBaseUrl,
          { MerchantId: this.$store.getters.currentMerchant },
          param
        )
        .then((res) => {
          if (this.firstTime) {
            this.conversaionList = res.data.list;
            this.newThreads = [];
            if (this.conversaionList) {
              this.conversaionList.forEach((xhat) => {
                if (!xhat.isMine && xhat.status == 'Sent') {
                  this.isntRead.unshift(xhat);
                } else {
                  this.isReads.unshift(xhat);
                }
              });
            }
          } else {
            // this.conversaionList = res.data.list.reverse()
            this.conversaionList = res.data.list;
            this.newThreads = [];
            if (this.conversaionList) {
              this.conversaionList.forEach((xhat) => {
                if (!xhat.isMine && xhat.status == 'Sent') {
                  this.isntRead.unshift(xhat);
                } else {
                  this.isReads.unshift(xhat);
                }
              });
            }
          }
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
        })
        .finally(() => {
          loader.hide();
          if (this.firstTime) {
            this.counter++;
            let h = document.getElementById('scroll');
            h.scrollTop = h.scrollHeight;
            this.scrollHeight = h.scrollHeight;
            this.firstTime = false;
          } else {
            let h = document.getElementById('scroll');
            h.scrollTop = h.scrollHeight - this.scrollHeight;
            this.scrollHeight = h.scrollHeight;
          }
        });
    },
    getUserDetail() {
      authRepository()
        .getUserDetail(this.$store.getters.authBaseUrl)
        .then((res) => {
          this.user = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    openImage(url) {
      window.open(url, '_blank');
    },
    newChat() {
      this.openNewChatForm = true;
      this.openEditChat = false;
      this.selectedChatForEdit = null;
    },
    closeChatForm() {
      this.openNewChatForm = false;
      this.openEditChat = false;
      this.selectedChatForEdit = null;
    },
    closeReplyForm() {
      this.showReply = false;
      this.selectedToReply = null;
    },
    editChat(chat) {
      this.openEditChat = true;
      this.selectedChatForEdit = chat;
      this.openNewChatForm = false;
      this.showReply = false;
      this.selectedToReply = null;
    },
    replyChat(item) {
      this.showReply = true;
      this.selectedToReply = item;
      this.openEditChat = false;
      this.openNewChatForm = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment {
  cursor: pointer;
}
.reply-color {
  background-color: aquamarine;
}
</style>
